import React from 'react';
import moment from 'moment';

import Styles from './ActiveStatus.module.scss';

const ActiveStatus = () => {

  const statusFunction = () => {
     if( moment('2021-12-13 19:59:59-07:00').isBefore(moment()) ) {
      return {
        text: 'Competition is Closed',
        style: Styles.closed
      }
    } else if(moment('2021-12-10 8:59:59-07:00').isAfter(moment())) {
      return {
        text: 'Competition is Upcoming',
        style: Styles.upcoming
      }
    } else if( moment('2021-12-13 19:59:59-07:00').isAfter(moment()) ) {
      return {
        text: 'Competition is Live!',
        style: Styles.open
      }
    }
  }

  const status = statusFunction();

  return (
    <div className={Styles.activeStatus}>
      <p className={Styles.soon + ' ' + status.style}>{status.text}</p>
    </div>
  )
};

export default ActiveStatus;